module.exports = __webpack_public_path__ + "static/img/network_edu_bg.4f77929.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/network_edu_bg.png
// module id = coSk
// module chunks = 0